import { colours } from "./colours";

declare module "@emotion/react" {
  export interface Theme {
    colours: typeof colours;
  }
}

export const theme = {
  colours: colours,
};
